// Tabs and copy controls for the server-rendered prompt report on playground
// results. The report is already in the HTML; this module only reveals panes
// and copies their exact text, so the page remains useful without JavaScript.
const boundPanels = new WeakSet();

const selectTab = (panel, key) => {
  panel.querySelectorAll('[data-prompt-tab]').forEach(tab => {
    const selected = tab.dataset.promptTab === key;
    tab.setAttribute('aria-selected', String(selected));
    tab.tabIndex = selected ? 0 : -1;
  });
  panel.querySelectorAll('[data-prompt-pane]').forEach(pane => {
    pane.hidden = pane.dataset.promptPane !== key;
  });
};

const fallbackCopy = text => {
  const input = document.createElement('textarea');
  input.value = text;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  input.remove();
};

const copyText = async text => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
  } else {
    fallbackCopy(text);
  }
};

const initialize = panel => {
  if (boundPanels.has(panel)) return;
  boundPanels.add(panel);

  panel.querySelectorAll('[data-prompt-tab]').forEach(tab => {
    tab.addEventListener('click', () => selectTab(panel, tab.dataset.promptTab));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      const tabs = [...panel.querySelectorAll('[data-prompt-tab]')];
      const offset = event.key === 'ArrowRight' ? 1 : -1;
      const next = tabs[(tabs.indexOf(tab) + offset + tabs.length) % tabs.length];
      selectTab(panel, next.dataset.promptTab);
      next.focus();
      event.preventDefault();
    });
  });

  panel.querySelectorAll('[data-prompt-copy-target]').forEach(button => {
    button.addEventListener('click', async () => {
      const target = document.getElementById(button.dataset.promptCopyTarget);
      if (!target) return;
      const original = button.textContent;
      try {
        await copyText(target.textContent);
        button.textContent = 'Copied';
      } catch (_error) {
        button.textContent = 'Copy failed';
      }
      window.setTimeout(() => { button.textContent = original; }, 1500);
    });
  });
};

const initializePage = () => {
  document.querySelectorAll('[data-playground-prompt-panel]').forEach(initialize);
};

document.addEventListener('DOMContentLoaded', initializePage);
document.addEventListener('turbolinks:load', initializePage);
